var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.picture)?_c('div',[_c('img',{staticClass:"avatar-image",attrs:{"alt":_vm.userName,"src":`/storage/mediapool/profile_images/${_vm.picture}`}})]):_c('div',[_c('img',{staticClass:"avatar-image",attrs:{"alt":'No picture',"src":'/img/avatar.png'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }